export default "__VITE_ASSET__ydSdMLdu__"